<script>
import ElButton from "./ElButton";

export default {
    name: "BackToTopBtn",
    components: { ElButton },
    data: () => ({
        scTimer: 0,
        scY: 0,
    }),

    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },

    methods: {
        handleScroll() {
            if (this.scTimer) return;

            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },

        toTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },
};
</script>

<template>
    <Transition name="fade">
        <div id="pagetop" class="back_to_top" v-show="scY > 550">
            <ElButton
                size="medium"
                type="grey"
                circle
                v-show="scY > 550"
                aria-label="Back to top"
                @click="toTop"
            >
                <template #icon-left>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="-3.5 0 16 16"
                    >
                        <path
                            fill="currentColor"
                            d="M4.5 14c-.28 0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5s.5.22.5.5v9c0 .28-.22.5-.5.5"
                        />
                        <path
                            fill="currentColor"
                            d="M8 7.5a.47.47 0 0 1-.35-.15L4.5 4.2L1.35 7.35c-.2.2-.51.2-.71 0s-.2-.51 0-.71l3.5-3.5c.2-.2.51-.2.71 0l3.5 3.5c.2.2.2.51 0 .71c-.1.1-.23.15-.35.15"
                        />
                    </svg>
                </template>
            </ElButton>
        </div>
    </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.back_to_top {
    position: fixed;
    right: 15px;
    bottom: 30px;
    z-index: 100;
    transition: 0.3s;
}

.back_to_top .el-button {
    --svg--size: 24px;
}
.back_to_top .el-button svg {
    width: 100%;
    height: 100%;
}
</style>
